export default __webpack_public_path__ + "static/layout-dont-dark-7c96f60fbd258f1f538cb847b5458618.png";